// © Microsoft Corporation. All rights reserved.

/**
 * An interface to represent the Publisher.
 *
 * @export
 * @interface Publisher
 */
export interface Publisher {
    id: string,
    createdDateTime: string,
    logos: Array<{
        width: number;
        height: number;
        imageLink: {href: string};
    }>;
    name: string;
    companyLegalName: string;
    displayName: string;
}

/**
 * Supported Publisher Actions
 */
export enum PublisherActions {
    More = "More",
    Mute = "Mute"
}